import { Separator } from '@shadcn/components/separator';
import styled from 'styled-components';

export const SettingsPageContainer = styled.div`
  width: 100%;
  max-width: 64rem;
  margin: 0 auto;
  padding: 4rem 2rem;
  height: 100%;
  overflow-y: auto;
`;

export const SettingsHeaderContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex flex-col mb-6">
    <SettingsHeaderContainerStyle>{children}</SettingsHeaderContainerStyle>
    <Separator className="mt-4" />
  </div>
);

const SettingsHeaderContainerStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SettingsHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const SettingsHeaderText = styled.div`
  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.025em;
  }
  div {
    font-size: 0.875rem;
    color: hsl(var(--muted-foreground));
  }
`;

export const SettingsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const SettingsSectionHeader = styled.h3`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;
